// extracted by mini-css-extract-plugin
export default {"h4":"lD0wdGqE_pg9r_YaN5O_","bold":"eSyKM9VNF_l43OBcuoLz","pink":"cUMsfL4UwhTc_pg3Gizd"};